/**
 * Renders a 14x14 swatch matching the symbology the map draws for a given
 * legend entry. Keeps map + legend visually consistent.
 */
export default function LegendSwatch({ shape, color, opacity }) {
  const size = 14;
  const base = { width: size, height: size, display: 'inline-block', flexShrink: 0 };

  switch (shape) {
    case 'circle':
      return (
        <span
          aria-hidden="true"
          style={{ ...base, background: color, opacity: opacity ?? 0.95, borderRadius: '50%', border: '1px solid #fff', boxShadow: `0 0 0 1px ${color}` }}
        />
      );
    case 'square':
      return <span aria-hidden="true" style={{ ...base, background: color, opacity: opacity ?? 0.95 }} />;
    case 'diamond':
      return (
        <span
          aria-hidden="true"
          style={{ ...base, background: color, opacity: opacity ?? 0.95, transform: 'rotate(45deg)', transformOrigin: 'center' }}
        />
      );
    case 'cross':
      return (
        <span aria-hidden="true" style={{ ...base, position: 'relative', color, fontWeight: 700, fontSize: 18, lineHeight: '14px', textAlign: 'center' }}>+</span>
      );
    case 'star':
      return (
        <span aria-hidden="true" style={{ ...base, color, fontSize: 16, lineHeight: '14px', textAlign: 'center' }}>★</span>
      );
    case 'dashed-line':
      return (
        <span
          aria-hidden="true"
          style={{
            ...base,
            height: 2,
            marginTop: 6,
            backgroundImage: `linear-gradient(to right, ${color} 50%, transparent 50%)`,
            backgroundSize: '6px 2px',
            backgroundRepeat: 'repeat-x',
          }}
        />
      );
    case 'polygon':
    default:
      return (
        <span
          aria-hidden="true"
          style={{ ...base, background: color, opacity: opacity ?? 0.9, border: `1px solid ${color}`, borderRadius: 2 }}
        />
      );
  }
}
